import { uuid4 } from '@sentry/core';
import * as BlipSdk from 'blip-sdk';
import * as WebSocketTransport from 'lime-transport-websocket';
export class ChatBrainService {
    static $inject = ['$cookies'];
    constructor($cookies) {
        'ngInject';
        this.$cookies = $cookies;
        this.DOMAIN = '0mn.io';
        this.uri = 'wss://aiconsultancy.ws.0mn.io:443';
        this.to = '';
        if (window.location.host.indexOf('hmg') > -1 || window.location.host.indexOf('akita') > -1) {
            this.to = 'brainhmg@msging.net';
        }
        else {
            this.to = 'brain4@msging.net';
        }
    }
    async connectAsGuest(botId, tenant_id, access_token, issuer, hostname) {
        const scheme = this.uri.match(/^(\w+):\/\//)[1];
        const hostName = this.uri.match(/:\/\/([^:\/]+)([:\/]|$)/)[1];
        const portMatch = this.uri.match(/:(\d+)/);
        const port = portMatch ? portMatch[1] : '8081';
        let randomUserIdentifier = '';
        const cookie = this.$cookies.getObject(`blip-identity-${botId}`);
        if (cookie == undefined) {
            randomUserIdentifier = `${uuid4()}.${botId}`;
            const expiration = new Date();
            expiration.setDate(expiration.getDate() + 5);
            this.$cookies.putObject(`blip-identity-${botId}`, randomUserIdentifier, { expiration, path: '/' });
        }
        else {
            randomUserIdentifier = this.$cookies.getObject(`blip-identity-${botId}`);
        }
        const identity = `${randomUserIdentifier}@${this.DOMAIN}`;
        const randomUserPassword = 'MTIzNDU2';
        const guestIdentifier = uuid4();
        const guestClient = new BlipSdk.ClientBuilder()
            .withScheme(scheme)
            .withHostName(hostName)
            .withPort(port)
            .withDomain(this.DOMAIN)
            .withTransportFactory(() => new WebSocketTransport({ localNode: identity }))
            .build();
        await guestClient.connectWithGuest(guestIdentifier);
        const createAccountCommand = {
            id: uuid4(),
            from: identity,
            pp: `${guestIdentifier}@${this.DOMAIN}/default`,
            method: 'set',
            type: 'application/vnd.lime.account+json',
            uri: '/account',
            resource: { password: randomUserPassword },
        };
        await guestClient.sendCommand(createAccountCommand);
        await guestClient.close();
        this.client = new BlipSdk.ClientBuilder()
            .withIdentifier(randomUserIdentifier)
            .withPassword(randomUserPassword)
            .withScheme(scheme)
            .withHostName(hostName)
            .withPort(port)
            .withDomain(this.DOMAIN)
            .withTransportFactory(() => new WebSocketTransport({ localNode: identity }))
            .build();
        this.client.addMessageReceiver(null, (message) => {
            if (this.onMessageCallback) {
                this.onMessageCallback(message);
            }
        });
        await this.client.connect();
        await this.sendMessageWithMetadata(botId, tenant_id, access_token, issuer, hostname);
    }
    async recoverMesssages() {
        return await this.client.sendCommand({
            'id': '81889038-ccd9-43b6-8f44-056044d6bbb7',
            'method': 'get',
            'to': 'postmaster@threads.0mn.io',
            'uri': `/threads/${this.to}?$take=40&direction=desc&refreshExpiredMedia=true`,
        });
    }
    async sendMessage(content) {
        if (!this.client)
            throw new Error('Cliente não conectado');
        const message = {
            id: uuid4(),
            to: this.to,
            type: 'text/plain',
            content,
        };
        await this.client.sendMessage(message);
    }
    async sendMessageWithMetadata(botId, tenant_id, access_token, issuer, hostname) {
        await this.client.sendMessage({
            to: this.to,
            type: 'application/json',
            content: { 'type': 'session/authenticate', 'version': 'agents-copilot', 'bot_id': botId, 'tenant_id': tenant_id, 'access_token': access_token, 'issuer': issuer, 'hostname': hostname },
            metadata: {
                '#blip.hiddenMessage': true,
            },
        });
    }
    onMessage(callback) {
        this.onMessageCallback = callback;
    }
    async close() {
        if (!this.client)
            return;
        await this.client.close();
        this.client = null;
    }
}
// Explicit AngularJS DI annotation for minification safety
// Order must match constructor parameter order
ChatBrainService.$inject = ['$cookies'];
